const LOG_LEVEL_INFO = "info";
const LOG_LEVEL_WARNING = "warning";
const LOG_LEVEL_ERROR = "error";


export const logInfo = (logMessage, ...optionalParams) => {
    logToConsole(LOG_LEVEL_INFO, logMessage, ...optionalParams)
}

export const logWarning = (logMessage , ...optionalParams) => {
    logToConsole(LOG_LEVEL_WARNING, logMessage, ...optionalParams)
}

export const logError = (logMessage, ...optionalParams) => {
    logToConsole(LOG_LEVEL_ERROR, logMessage, ...optionalParams)
}

const logToConsole = (logLevel, logMessage,  ...optionalParams) => {
    switch (logLevel) {
        case LOG_LEVEL_INFO:
            console.log(logMessage, ...optionalParams)
            break;
        case LOG_LEVEL_WARNING:
            console.warn(logMessage, ...optionalParams)
            break;
        case LOG_LEVEL_ERROR:
            console.error(logMessage, ...optionalParams)
            break;
        default:
            break;
    }
}



// WEBPACK FOOTER //
// ./src/common/Logger.js